import moment from 'moment'

export const tableColumns = [
  {
    title: "货品sku编码",
    dataIndex: "shipperGoodsCode",
  },
  {
    title: "货品名称",
    dataIndex: "goodsName",
    scopedSlots: { customRender: "goodsName" },
    width: 450,
  },
  {
    title: "仓库名称",
    dataIndex: "warehouseName",
  },
  {
    title: "在库可用库存",
    dataIndex: "stock",
  },
  {
    title: "预估可用天数",
    dataIndex: "useDays",
    customRender: text => `${text || ''}天`,
  },
  {
    title: "预估补货量",
    dataIndex: "amount",
    scopedSlots: { customRender: "amount" },
  },
  {
    title: "最晚补货日期",
    dataIndex: "lastTime",
    customRender: text => text ? moment(text || '').format('YYYY-MM-DD') : '',
  },
  {
    title: "操作",
    dataIndex: "action",
    scopedSlots: { customRender: "action" },
  },
]

export const replenishmentType = ['info', 'iframe']

export const RECORDCOLUMN = [
  {
    title: '上架时间',
    dataIndex: 'upperTime',
    customRender: text => moment(text || '').format('YYYY-MM-DD HH:mm:ss'),
    width: 140,
  },
  {
    title: '入库单号',
    dataIndex: 'storeNo',
    width: 140,
  },
  {
    title: '入库类型',
    dataIndex: 'storeType',
    width: 110,
  },
  {
    title: '批次',
    dataIndex: 'batchNo',
    width: 140,
  },
  {
    title: '温层',
    dataIndex: 'temperatureLayerName',
    width: 40,
  },
  {
    title: '生产日期',
    dataIndex: 'productTime',
    customRender: text => moment(text || '').format('YYYY-MM-DD'),
    width: 90,
  },
  {
    title: '到期日期',
    dataIndex: 'expireTime',
    customRender: text => moment(text || '').format('YYYY-MM-DD'),
    width: 90,
  },
  {
    title: '上架数量',
    dataIndex: 'upperAmount',
    width: 80,
  },
]